import '@gjensidige/core-fonts';

import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';

import Layout from '../layout';
import { ChangePassword } from '../pages/change-password';
import { Login } from '../pages/login';
import { LoginGuest } from '../pages/login-guests';
import { RegisterUser } from '../pages/register-user';
import { ResetPassword } from '../pages/reset-password';

interface Props {
  config?: {
    ad: string;
    exp: string;
  };
}

export const Router: React.FC<Props> = ({ config }) => {
  return (
    <BrowserRouter basename="/login">
      <Switch>
        <Route exact path="/">
          <Layout>
            <Login adUrl={config?.ad || '/azure-ad'} />
          </Layout>
        </Route>
        <Route
          path={'/guests'}
          render={() => (
            <Layout page={'guests'}>
              <LoginGuest />
            </Layout>
          )}
        />
        <Route
          path={'/register-user'}
          render={() => (
            <Layout page={'guests'}>
              <RegisterUser />
            </Layout>
          )}
        />
        <Route
          path={'/change-password'}
          render={() => {
            return (
              <Layout page={'guests'}>
                <ChangePassword />{' '}
              </Layout>
            );
          }}
        />
        <Route
          path={'/forgot-password'}
          render={() => (
            <Layout page={'guests'}>
              <ResetPassword />
            </Layout>
          )}
        />
        <Route
          path={'/test-successful-login'}
          render={() => (
            <Layout>
              <h1>LOGIN TEST OK</h1>
            </Layout>
          )}
        />
        <Redirect to="/" />
      </Switch>
    </BrowserRouter>
  );
};
